import { FC } from 'react';
import { Field, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { HexColor } from '@gn-audio/jss-components/utils';

import Banner from 'common/components/Banner';
import { mapSharedPropertiesToFields } from 'common/getters';
import { ComponentProps } from 'lib/component-props';

export type TextBannerProps = ComponentProps & {
  fields: {
    Title: Field<string>;
    Body: Field<string>;
    BackgroundColor: Field<string>;
    BottomOverlapHeight: Field<string>;
  };
};

const TextBanner: FC<TextBannerProps> = ({ fields }) => {
  const textBanner = mapSharedPropertiesToFields<TextBannerProps['fields']>(fields);
  return (
    <Banner
      bottomOverlapHeight={textBanner.BottomOverlapHeight.value}
      title={textBanner.Title.value}
      backgroundColor={textBanner.BackgroundColor.value as HexColor}
      body={textBanner.Body.value}
    />
  );
};

export default withDatasourceCheck()<TextBannerProps>(TextBanner);
